import { useEffect, useCallback } from 'react';

const NotificationListeners = ({ eventEmitter, applyStoreAction }) => {
    const notificationAdded = useCallback(notification => {
        applyStoreAction({
            type: 'NOTIFICATION_ADD_SOCKET',
            payload: { notification }
        });
    }, [applyStoreAction]);

    const notificationRead = useCallback(({ ids: notificationIds }) => {
        applyStoreAction({
            type: 'NOTIFICATIONS_READ_SOCKET',
            payload: { notificationIds }
        });
    }, [applyStoreAction]);

    const notificationUnread = useCallback(({ ids: notificationIds }) => {
        applyStoreAction({
            type: 'NOTIFICATIONS_UNREAD_SOCKET',
            payload: { notificationIds }
        });
    }, [applyStoreAction]);

    const notificationUpdate = useCallback(notification => {
        applyStoreAction({
            type: 'NOTIFICATIONS_UPDATE_SOCKET',
            payload: { notification }
        });
    }, [applyStoreAction]);

    const notificationRemove = useCallback(({ ids: notificationIds }) => {
        applyStoreAction({
            type: 'NOTIFICATIONS_REMOVE_SOCKET',
            payload: { notificationIds }
        });
    }, [applyStoreAction]);

    const listen = () => {
        eventEmitter.on('new_notification', notificationAdded);
        eventEmitter.on('notification_read', notificationRead);
        eventEmitter.on('notification_unread', notificationUnread);
        eventEmitter.on('notification_update', notificationUpdate);
        eventEmitter.on('notification_remove', notificationRemove);

        return () => {
            eventEmitter.off('new_notification', notificationAdded);
            eventEmitter.off('notification_read', notificationRead);
            eventEmitter.off('notification_unread', notificationUnread);
            eventEmitter.off('notification_update', notificationUpdate);
            eventEmitter.off('notification_remove', notificationRemove);
        };
    };

    useEffect(listen, [eventEmitter, notificationAdded, notificationRead, notificationUnread, notificationUpdate, notificationRemove]);

    return null;
}

export default NotificationListeners;
